import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  cardContainer: {
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    width: 248,
    height: 400,
    borderRadius: 8,
    marginTop: 20,
    marginBottom: 20,
    paddingHorizontal: 20,
    paddingVertical: 40,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  headerQuantSelos: {
    fontSize: 60,
    color: "#077A97",
    marginBottom: 0,
  },

  txtGeral: {
    textAlign: "center",
    color: "#077A97",
  },

  containerPorSifraoValor: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  txtGeralLight: {
    textAlign: "center",
    color: "#FFF",
  },

  btnComprarPacote: {
    padding: 10,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },

  btnComprarPacoteLight: {
    padding: 10,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#FFF",
    position: "relative",
  },

  txtBtnComprarPacote: {
    color: "#FFF",
  },

  txtBtnComprarPacoteLight: {
    color: "#077A97",
  },

  containerCardsPacotes: {
    alignSelf: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    alignItems: "center",
    maxWidth: "90%",
  },

  containerSubTexto: {
    alignItems: "center",
    marginBottom: 30,
    marginTop: 30,
  },
});

export default styles;
